// extracted by mini-css-extract-plugin
module.exports = {"rating":"rating","rating__icon":"rating__icon","ratingIcon":"rating__icon"};